// extracted by mini-css-extract-plugin
module.exports = {"widthContainer":"_19K_KpemS-soWx9P9cIDiL","container":"_28rsgTNwy1SLrjdZOnOixg","wide":"_6JbekrUgLUk8NukZrPNdn"};